module.exports = __webpack_public_path__ + "9fad4b05fcc98f050c187283d101afd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-post-header/icon-comments.png
// module id = ./src/components/blog-post-header/icon-comments.png
// module chunks = index